import { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  IconButton,
  InputAdornment,
  Icon,
  Button,
  CircularProgress,
} from "@material-ui/core";
import FormikField from "../components/FormFields/FormikField";
import { useStateAuthValue } from "../context/AuthState";
import { useNavigate } from "react-router-dom";
import { login } from "../services/authService";
import { useToast } from "../context/Toast/ToastProvider";
import { showToast, ToastType } from "../utils/ToastUtil";
import { loginStyles } from "../styles/makeStyles.js"
import Logo from "../assets/images/logo.png";

const Login = () => {
  const classes = loginStyles();
  const navigate = useNavigate();
  const [{}, dispatch] = useStateAuthValue();
  const toastDispatch = useToast();
  const [hidePassword, seHidePassword] = useState(true);

  const LoginScheme = Yup.object().shape({
    username: Yup.string()
      .email("Debe ingresar un email válido")
      .required("Email Requerido"),
    password: Yup.string()
      .min(6, " Debe tener al menos 6 caracteres")
      .required("Debe ingresar una contraseña"),
  });

  const handleClickShowPassword = () => seHidePassword(!hidePassword);

  const IconVisible = (icon) => {
    return <Icon className={classes.visibility}> {icon}</Icon>;
  };

  return (
    <div className="login">
      <div className="login__card">
        <aside className="login__brand">
          <img alt="Mediline" className="login__logo" src={Logo} />
          <h1 className="login__brand-title">Backoffice Mediline</h1>
          <p className="login__brand-text">
            Gestión de socios, profesionales, planes y ventas en un solo lugar.
          </p>
        </aside>

        <div className="login__form">
          <h2 className="login__title">Iniciar sesión</h2>
          <p className="login__subtitle">
            Ingresá tus credenciales para continuar.
          </p>
          <Formik
            initialValues={{
              username: "",
              password: "",
            }}
            onSubmit={async (values) => {
              const displayError = (msg) => showToast(toastDispatch, msg, ToastType.ERROR, ToastType.ERROR);
              const response = await login(values, displayError);
              if (response) {
                localStorage.setItem("token", response.id_token);
                localStorage.setItem("role", response.role);
                localStorage.setItem("username", values.username);
                dispatch({
                  type: "LOG_IN",
                  userData: response,
                  userToken: response.id_token,
                  userRole: response.role,
                });
                navigate("/");
              }
            }}
            validationSchema={LoginScheme}
          >
            {({ dirty, isValid, isSubmitting }) => {
              return (
                <Form>
                  <FormikField
                    name="username"
                    label="Email"
                    variant="outlined"
                  />
                  <FormikField
                    name="password"
                    label="Contraseña"
                    variant="outlined"
                    type={hidePassword ? "password" : "text"}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className={classes.iconButton}
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                          >
                            {hidePassword
                              ? IconVisible("visibility_off")
                              : IconVisible("visibility")}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Button
                    disabled={!(isValid && dirty) || isSubmitting}
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={`${classes.submit} ${
                      isSubmitting ? classes.submitLoading : ""
                    }`}
                    endIcon={
                      isSubmitting ? null : <Icon>chevron_right</Icon>
                    }
                  >
                    {isSubmitting ? (
                      <CircularProgress size={22} thickness={4.5} color="inherit" />
                    ) : (
                      "Ingresar"
                    )}
                  </Button>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Login;
